export enum EConditionStockage {
    StockageESET = 1,
    Bac = 2,
    ChampStérile = 3,
    EnsachéSousAirMedical = 4,
    SousVide = 5,
    Tiroir = 6,
    AutreQueESET = 7,
    EauStérile = 8,
}